/**
 * After a deploy, a tab opened earlier still points at the previous build's page chunks, which are
 * gone from the server. Loading one fails; one full reload fetches the new index.html and fixes it.
 * The sessionStorage guard makes sure we reload at most once per tab, so a real outage can't loop.
 */
const KEY = 'admin:chunk-reload-at';
/** A second failure within this window is treated as real, not a stale build. */
const WINDOW_MS = 60_000;

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    error.name === 'ChunkLoadError' ||
    /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(
      error.message,
    )
  );
}

/** Reload once for a stale chunk. Returns false (no reload) if we already tried recently. */
export function reloadOnceForStaleChunk(
  storage: Pick<Storage, 'getItem' | 'setItem'> = sessionStorage,
  reload: () => void = () => {
    window.location.reload();
  },
  now: number = Date.now(),
): boolean {
  const last = Number(storage.getItem(KEY) ?? 0);
  if (last && now - last < WINDOW_MS) return false;
  storage.setItem(KEY, String(now));
  reload();
  return true;
}
